import { combineReducers } from 'redux'

const hasTouch = (
  state = typeof document !== 'undefined' &&
    'ontouchstart' in document.documentElement
) => {
  return state
}

export default combineReducers({
  hasTouch,
})
